module.exports = __webpack_public_path__ + "static/number-2-25a4a260e5644785eb1da32bb2d8ce96.webp";